import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {TaskModel} from "../../../tasks/models/task.model";

export class DeliveryLinkedServicesComponent implements IController {
  delivery: any;
  onUnlinkRelatedTask: Function;

  private relations: any[] = [];
  blockingRelations: any[] = [];
  supplyTogetherRelations: any[] = [];
  referencesRelations: any[] = [];
  referenceByRelations: any[] = [];
  blockedRelations: any[] = [];
  deliveryRelation: any;
  // deliveryTaskTypesMap: any;

  constructor() {
  }

  $onInit() {
    this.initRelations();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.delivery && !changes.delivery.isFirstChange()) {
      this.initRelations();
    }
  }

  private initRelations() {
    // this.deliveryTaskTypesMap = {};
    // this.delivery.taskList.forEach(t => {
    //   this.deliveryTaskTypesMap[t.id] = t.taskSpec.purpose;
    // })
    this.relations = _.compact(_.flatMap(this.delivery.taskList, 'relations'));
    this.blockedRelations = _.filter(this.relations, (relation) => {
      return relation.type === "BlockedBy";
    })
    this.blockingRelations = _.filter(this.relations, (relation) => {
      return relation.type === "Blocking";
    })
    this.supplyTogetherRelations = _.filter(this.relations, (relation) => {
      return relation.type === "SupplyTogether";
    })
    this.referencesRelations = _.filter(this.relations, (relation) => {
      return relation.type === "References";
    })
    this.referenceByRelations = _.filter(this.relations, (relation) => {
      return relation.type === "ReferencedBy";
    })

    this.deliveryRelation = {
      details: {
        status: this.delivery.status,
        taskNotBefore: this.delivery.notBefore,
        taskNotAfter: this.delivery.notAfter,
        agentFirstName: _.get(this.delivery, 'agentReference.firstName'),
        agentLastName: _.get(this.delivery, 'agentReference.lastName'),
        agentId: _.get(this.delivery, 'agentReference.id')
      }
    }
  }


}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryLinkedServices', {
    bindings: {
      delivery: '<',
      onUnlinkRelatedTask: '&'
    },
    template: require('./delivery-linked-services.html').default,
    controller: DeliveryLinkedServicesComponent
  });
